/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Challenge_PhysicalInputs */

const en_onboarding_challenge_physical = /** @type {(inputs: Onboarding_Challenge_PhysicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitting is physically painful`)
};

const es_onboarding_challenge_physical = /** @type {(inputs: Onboarding_Challenge_PhysicalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estar sentado es físicamente doloroso`)
};

/**
* | output |
* | --- |
* | "Sitting is physically painful" |
*
* @param {Onboarding_Challenge_PhysicalInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_challenge_physical = /** @type {((inputs?: Onboarding_Challenge_PhysicalInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Challenge_PhysicalInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_challenge_physical(inputs)
	return en_onboarding_challenge_physical(inputs)
});